/** Shared with catalogue prewarm: native image cache keys include the requested width. */
export const GAME_PARAMETER_IMAGE_SIZES = {
  trigger: 20,
  singleRow: 20,
  multipleRow: 28,
  selectedTag: 24,
} as const;
